/* eslint-disable security/detect-object-injection */
/* eslint-disable import/no-unresolved */
import Button from "@mui/material/Button";
import { useFormik } from "formik";
import { memo, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setStepDetails } from "src/redux/Actions/common";
import { setPincodeData, setProposerDetails } from "src/redux/Actions/proposerDetails";
import { deleteNominee, setNomineeDetails } from "src/redux/Thunk";
import store from "src/redux/store";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import {
  nomineeIndividualField,
  validationSchema
} from "../../../../helpers/FormDetails/ProposalDetails/Nominee";
import AddMoreButton from "../../../../shared/AddMoreButton";
import CustomModal from "../../../../shared/CustomModal";
import PrimaryDetails from "./PrimaryDetails";

function Nominee() {
  const mefSchema = useAppSelector((state): any => state.masterdata_reducer?.mefJourneySchema);
  const nomineeDetailsSchema = mefSchema?.nomineeDetails || {};
  const dispatch = useDispatch();
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const nomineeDetails = useAppSelector((state) => state.proposerDetails.nominee);
  const [nominee, setNominee] = useState(nomineeDetails);
  const proposalStatus = useAppSelector((state) => state.proposalStatus.status);
  const handlePincodeClick = (data: any) => store.dispatch(setPincodeData(data));
  const isJointAddendumState = useAppSelector((state: any) => state.isJointAddendum.isJointState);

  const [customError, setCustomError] = useState<any>({});
  const formik = useFormik({
    enableReinitialize: true,
    validateOnMount: true,
    validateOnBlur: true,
    initialValues: nomineeDetails!,
    validationSchema: validationSchema(nomineeDetailsSchema),
    onSubmit: (fieldValues) => {
      if (proposalStatus !== "MEF Submitted") {
        store.dispatch(setNomineeDetails(fieldValues, { proposerStepNo: 4 }));
        window.scrollTo(0, 0);
      }
    }
  });

  useEffect(() => {
    formik.setValues(nominee!);
  }, [nominee]);

  const handleAddingMoreNominees = () => {
    const nomineeObj = { ...nomineeIndividualField };
    nomineeObj.share = "";
    setNominee({
      nominee: [...formik.values.nominee, nomineeObj]
    });
  };

  const handleRemoveClick = (nomineeIndex: number) => {
    const nomineeId = nominee?.nominee[nomineeIndex].id;
    if (nomineeId) {
      store.dispatch(deleteNominee(nomineeId));
    }
    const filteredNominee = formik.values?.nominee.filter((_, index) => index !== nomineeIndex);
    setNominee({
      nominee: filteredNominee
    });
    store.dispatch(
      setProposerDetails({
        nominee: { ...nominee, nominee: filteredNominee }
      })
    );
  };

  const handleProposerNomineeForm = () => {
    const isCustomError: boolean =
      Object.values(customError).filter((val: any) => !!val).length > 0;
    setModalOpen(!formik.isValid || isCustomError);
    if (!isCustomError) formik.handleSubmit();
  };
  return (
    <>
      <CustomModal modalOpen={modalOpen} setModalOpen={setModalOpen} />
      <div className="pr-10 pl-10.25 bg-white">
        {nominee?.nominee?.map((_, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <div className="py-8" key={index}>
            {index > 0 && <div className="w-full mb-10 border border-black opacity-30" />}
            <PrimaryDetails
              formik={formik}
              customError={customError}
              setCustomError={setCustomError}
              nomineeNumber={index}
              onRemoveClick={() => handleRemoveClick(index)}
              savePincodeDataToStore={handlePincodeClick}
              nomineeDetailsSchema={nomineeDetailsSchema}
            />
          </div>
        ))}
        <div>
          {nominee?.nominee?.length! <= 4 && (
            <AddMoreButton label="Add More Nominee (Max. 5)" onClick={handleAddingMoreNominees} />
          )}
          <div className="flex justify-center mt-10">
            <Button
              variant="outlined"
              classes={{ outlined: "!rounded-lg" }}
              onClick={() => {
                dispatch(setStepDetails({ proposerStepNo: 2 }));
                window.scrollTo(0, 0);
              }}
              className="!text-black !uppercase h-13 w-37.5 rounded-xl !mr-10"
            >
              Back
            </Button>
            <Button
              variant="contained"
              classes={{ contained: "!rounded-lg" }}
              onClick={handleProposerNomineeForm}
              className="!uppercase h-13 w-37.5"
            >
              NEXT
            </Button>
            {isJointAddendumState === "yes" && (
              <Button
                variant="outlined"
                classes={{ outlined: "!rounded-lg" }}
                onClick={() => {
                  dispatch(setStepDetails({ proposerStepNo: 4 }));
                  window.scrollTo(0, 0);
                }}
                className="!text-black !uppercase h-13 w-37.5 rounded-xl !ml-10"
              >
                SKIP
              </Button>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default memo(Nominee);
